import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox_active",
  "use": "checkbox_active-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"checkbox_active\"><g fill-rule=\"evenodd\" transform=\"translate(1 1)\"><rect height=\"13\" rx=\"2\" width=\"13\" x=\"-.5\" y=\"-.5\" /><path d=\"M2.08 5.968l2.997 2.997L10.042 4\" stroke=\"#fff\" stroke-width=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id